// src/directives/restrict.js
// Global directive: v-restrict
// Default: allows only letters (A–Z, a–z) and spaces

function resolveTarget(el) {
    if (el.matches?.('input,textarea,[contenteditable="true"]')) return el;
    return el.querySelector?.('input,textarea,[contenteditable="true"]') || el;
}

function buildRegex(binding) {
    // Modes:
    //   default               → allow letters + spaces
    //   .allow-alphanumeric   → allow letters + digits + spaces
    //   .allow-numeric        → allow digits only
    //   :<pattern>            → custom whitelist pattern, e.g. v-restrict:\s\-\_
    if (binding?.modifiers?.['allow-alphanumeric']) return /[^a-zA-Z0-9\s]/g;
    if (binding?.modifiers?.['allow-numeric']) return /[^0-9]/g;
    if (binding?.arg) return new RegExp(`[^${binding.arg}]`, 'g');

    // Default: remove everything that’s NOT a letter or space
    return /[^a-zA-Z\s]/g;
}

function sanitize(el, regex) {
    const isEditable = el.getAttribute?.('contenteditable') === 'true';
    const val = isEditable ? el.innerText : el.value ?? '';
    const filtered = String(val).replace(regex, '');
    if (filtered !== val) {
        if (isEditable) el.innerText = filtered; else el.value = filtered;
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }
}

function mount(el, binding) {
    const target = resolveTarget(el);
    const regex = buildRegex(binding);
    let composing = false;

    const onInput = (e) => { if (!composing) sanitize(target, regex); console.log(e)};
    const onPaste = (e) => {
        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text') || '';
        const filtered = text.replace(regex, '');
        document.execCommand?.('insertText', false, filtered);
        target.dispatchEvent(new Event('input', { bubbles: true }));
    };
    const onCompStart = () => (composing = true);
    const onCompEnd = (e) => { composing = false; onInput(e); };

    target.__restrictHandlers__ = { onInput, onPaste, onCompStart, onCompEnd };
    target.addEventListener('input', onInput);
    target.addEventListener('paste', onPaste);
    target.addEventListener('compositionstart', onCompStart);
    target.addEventListener('compositionend', onCompEnd);

    // Initial cleanup for any pre-filled values
    sanitize(target, regex);
}

function unmount(el) {
    const target = resolveTarget(el);
    const h = target.__restrictHandlers__;
    if (!h) return;
    target.removeEventListener('input', h.onInput);
    target.removeEventListener('paste', h.onPaste);
    target.removeEventListener('compositionstart', h.onCompStart);
    target.removeEventListener('compositionend', h.onCompEnd);
    delete target.__restrictHandlers__;
}

export default { mounted: mount, beforeUnmount: unmount };
